import React from "react";
//#region redux
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "store";
import { setLeftNavCollapsed } from "store/actions/utilActions";
//#endregion
//#region components
import { Button, Grid, Drawer } from "@mui/material";
import UserProfileContainer from "./userProfile/userProfileContainer";
import NavigationListContainer from "./navigation/navigationListContainer";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { useCompanyLoadingState, LoadingWithLogo } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const LeftNav: React.FC = () => {
  const collapsed = useSelector((store: AppState) => store.util.leftNavCollapsed);

  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(setLeftNavCollapsed(!collapsed));
  };

  const isCompanyLoading = useCompanyLoadingState();

  React.useEffect(() => {
    if (window.innerWidth <= 1584) {
      dispatch(setLeftNavCollapsed(true));
    }
  }, []);

  return (
    <Drawer
      className={clsx(cssExports.drawer, cssExports.leftNavContainer, collapsed ? cssExports.leftNavCollapsed : "")}
      variant="permanent"
      classes={{
        paper: cssExports.drawerPaper,
      }}
    >
      <Grid item className={cssExports.leftNavContent}>
        <Button className={cssExports.collapseNavButton} onClick={handleClick} disableRipple={true}>
          {collapsed ? <NavigateNextIcon /> : <NavigateBeforeIcon />}
        </Button>
        <UserProfileContainer collapsed={collapsed} />
        {isCompanyLoading ? (
          <LoadingWithLogo className={cssExports.transparentBackground} />
        ) : (
          <NavigationListContainer collapsed={collapsed} />
        )}
      </Grid>
    </Drawer>
  );
};

export default LeftNav;
